export default __webpack_public_path__ + "static/media/zoom-in.6c0949bc.svg";